module.exports = __webpack_public_path__ + "media/images/new/background_map_pattern-b2fcbe5f35c885088c086654f86ffbee.jpg";